import { useIntl } from "react-intl";

import { Pill, PillProps } from "ui/Pill/Pill";

export type StockPillProps = {
  stock?: number | string;
  customBgColor?: string;
} & Omit<PillProps, "children">;

export function StockPill({ stock, customBgColor = "white", ...rest }: StockPillProps) {
  const intl = useIntl();
  const { badgeColor, label } = stock
    ? {
        label: intl.formatMessage({ id: "components.stock-pill.lable.stock" }, { stock }),
        badgeColor: "veggie.500",
      }
    : {
        label: intl.formatMessage({ id: "components.stock-pill.lable.out-of-stock" }),
        badgeColor: "red",
      };

  return (
    <Pill bg={customBgColor} {...rest}>
      <Pill.Badge color={badgeColor} />
      <Pill.Text>{label}</Pill.Text>
    </Pill>
  );
}
